<template>
    <div class="menuleftmobile hide" id="menu-left-mobile">
        <div class="top_bar">
            <a href="/admin">
                <img src="/img/menu_logo.svg" alt="logo" />
            </a>
            <div class="close_menu" @click="hidemenu">
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.77505 0.800049C2.03364 0.800049 2.28163 0.908416 2.46448 1.10131C2.64733 1.2942 2.75005 1.55583 2.75005 1.82862V14.1715C2.75005 14.4443 2.64733 14.7059 2.46448 14.8988C2.28163 15.0917 2.03364 15.2 1.77505 15.2C1.51646 15.2 1.26847 15.0917 1.08562 14.8988C0.902772 14.7059 0.800049 14.4443 0.800049 14.1715V1.82862C0.800049 1.55583 0.902772 1.2942 1.08562 1.10131C1.26847 0.908416 1.51646 0.800049 1.77505 0.800049ZM9.28937 4.18713C9.47216 4.38002 9.57484 4.64159 9.57484 4.91433C9.57484 5.18707 9.47216 5.44865 9.28937 5.64153L8.0287 6.97148H15.425C15.6836 6.97148 15.9316 7.07984 16.1145 7.27274C16.2973 7.46563 16.4001 7.72725 16.4001 8.00005C16.4001 8.27284 16.2973 8.53446 16.1145 8.72736C15.9316 8.92025 15.6836 9.02862 15.425 9.02862H8.0287L9.28937 10.3586C9.46698 10.5526 9.56525 10.8124 9.56303 11.0821C9.56081 11.3517 9.45827 11.6097 9.2775 11.8004C9.09672 11.9911 8.85218 12.0993 8.59654 12.1017C8.3409 12.104 8.09461 12.0003 7.91072 11.813L4.98572 8.72725C4.80294 8.53436 4.70026 8.27279 4.70026 8.00005C4.70026 7.72731 4.80294 7.46573 4.98572 7.27285L7.91072 4.18713C8.09356 3.99431 8.34151 3.88598 8.60005 3.88598C8.85858 3.88598 9.10653 3.99431 9.28937 4.18713Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>
        <div class="top">
            <a href="/admin/offers/create" class="nova_cenova_ponuka topmenu" id="v-step-6">
                <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 0.5C7.26522 0.5 7.51957 0.605357 7.70711 0.792893C7.89464 0.98043 8 1.23478 8 1.5V6.5H13C13.2652 6.5 13.5196 6.60536 13.7071 6.79289C13.8946 6.98043 14 7.23478 14 7.5C14 7.76522 13.8946 8.01957 13.7071 8.20711C13.5196 8.39464 13.2652 8.5 13 8.5H8V13.5C8 13.7652 7.89464 14.0196 7.70711 14.2071C7.51957 14.3946 7.26522 14.5 7 14.5C6.73478 14.5 6.48043 14.3946 6.29289 14.2071C6.10536 14.0196 6 13.7652 6 13.5V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5C0 7.23478 0.105357 6.98043 0.292893 6.79289C0.48043 6.60536 0.734784 6.5 1 6.5H6V1.5C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5Z"
                        fill="white"
                    />
                </svg>
                {{ $t("menu.text_4") }}
            </a>
            <menu-item
                v-for="item in normal_items"
                :key="item.title"
                :data="item"
                :paid_type="paid_type"
            />
            <div class="premium_line">
                <!-- <span>
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.27706 1.04341L3.05721 2.56592L4.6432 0.667779C4.68761 0.614714 4.74376 0.572071 4.80748 0.543026C4.87119 0.513982 4.94083 0.499284 5.0112 0.500027C5.08157 0.50077 5.15087 0.516935 5.21392 0.547318C5.27697 0.577701 5.33216 0.621519 5.37537 0.67551L6.88885 2.56547L8.72653 1.02112C8.7987 0.960599 8.88816 0.922946 8.98295 0.913201C9.07774 0.903457 9.17332 0.922086 9.25692 0.966597C9.34051 1.01111 9.40813 1.07937 9.45071 1.16226C9.4933 1.24515 9.50882 1.3387 9.4952 1.4304L8.79344 6.13574H1.21765L0.505122 1.45177C0.490969 1.35957 0.506313 1.26536 0.549077 1.18191C0.59184 1.09846 0.659956 1.0298 0.7442 0.985237C0.828443 0.940671 0.924743 0.92235 1.02006 0.932754C1.11537 0.943159 1.20509 0.981786 1.27706 1.04341ZM1.25414 6.59049H8.73963V7.04525C8.73963 7.16585 8.69034 7.28152 8.60261 7.36681C8.51487 7.45209 8.39587 7.5 8.27179 7.5H1.72198C1.5979 7.5 1.47891 7.45209 1.39117 7.36681C1.30343 7.28152 1.25414 7.16585 1.25414 7.04525V6.59049Z" fill="#FEF3C7"/>
                    </svg>
                    {{ $t('menu.text_1') }}
                </span> -->
            </div>
            <div v-if="data.is_admin">
                <div id="v-step-8">
                    <menu-item
                        v-for="item in premium_items.slice(0, 3)"
                        :key="item.title"
                        :data="item"
                        :paid_type="paid_type"
                    />
                </div>
                <div id="v-step-9">
                    <menu-item
                        v-for="item in premium_items.slice(3, 6)"
                        :key="item.title"
                        :data="item"
                        :paid_type="paid_type"
                    />
                </div>
                <div class="admin_line">
                    <span>
                        {{ $t("menu.text_2") }}
                    </span>
                </div>
            </div>
            <menu-item
                v-for="item in admin_items"
                :key="item.title"
                :data="item"
                :paid_type="paid_type"
            />
            <div class="settings_line">
                <span>
                    {{ $t("menu.text_3") }}
                </span>
            </div>
            <div id="v-step-10">
                <menu-item
                    v-for="item in setting_items"
                    :key="item.title"
                    :data="item"
                    :paid_type="paid_type"
                />
            </div>
            <a href="/admin/offers/create" class="nova_cenova_ponuka">
                <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7 0.5C7.26522 0.5 7.51957 0.605357 7.70711 0.792893C7.89464 0.98043 8 1.23478 8 1.5V6.5H13C13.2652 6.5 13.5196 6.60536 13.7071 6.79289C13.8946 6.98043 14 7.23478 14 7.5C14 7.76522 13.8946 8.01957 13.7071 8.20711C13.5196 8.39464 13.2652 8.5 13 8.5H8V13.5C8 13.7652 7.89464 14.0196 7.70711 14.2071C7.51957 14.3946 7.26522 14.5 7 14.5C6.73478 14.5 6.48043 14.3946 6.29289 14.2071C6.10536 14.0196 6 13.7652 6 13.5V8.5H1C0.734784 8.5 0.48043 8.39464 0.292893 8.20711C0.105357 8.01957 0 7.76522 0 7.5C0 7.23478 0.105357 6.98043 0.292893 6.79289C0.48043 6.60536 0.734784 6.5 1 6.5H6V1.5C6 1.23478 6.10536 0.98043 6.29289 0.792893C6.48043 0.605357 6.73478 0.5 7 0.5Z"
                        fill="white"
                    />
                </svg>
                {{ $t("menu.text_4") }}
            </a>
            <a href="/admin/feedback" class="feedback">
                {{ $t("menu.text_5") }}
            </a>
        </div>
        <div class="bottom">
            <a href="/admin/changelog" class="change-log">
                {{ $t("menu.text_6") }} {{ json[0].version }}
            </a>
        </div>
    </div>
</template>

<script>
import MenuItem from "./components/MenuItem.vue";
import json from "../../admin/changelog/changelog.json";
import menulisting from "./menulisting";
export default {
    components: { MenuItem },
    props: ["data", "amiowner", "paid_type"],
    data() {
        return {
            json: json.changelogs,
            normal_items: null,
            setting_items: null,
            premium_items: null,
            admin_items: null,
        };
    },
    created() {
        this.normal_items = menulisting["normal_items"];
        this.setting_items = menulisting["setting_items"];
        this.premium_items = menulisting["premium_items"];
        this.admin_items = menulisting["admin_items"];

        const itemToUpdate = this.premium_items.find((item) => item.title === "menu.mojiPouzivatelia");
        if (itemToUpdate) {
            itemToUpdate.show = this.amiowner;
        }
    },
    methods: {
        hidemenu() {
            $(".menuleftmobile").addClass("hide");
            $(".pcoded-content").addClass("hide");
        },
    },
};
</script>

<style lang="scss" scoped>
.menuleftmobile {
    pointer-events: all;
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    transition: 0.5s all;
    position: fixed;
    width: 300px;
    height: 104%;
    left: 0;
    top: 0;
    background: linear-gradient(0deg, #212541, #212541), #ffffff;
    z-index: 1028;
    .top_bar {
        width: 300px;
        background: linear-gradient(0deg, #212541, #212541), #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 61px;
        padding: 0 16px 0 32px;
        img {
            width: 120px;
        }
        .close_menu {
            width: 36px;
            height: 36px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            svg {
                transition: 0.5s all;
            }
            &.roll {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
    }
    @media only screen and (max-width: 1100px) {
        display: flex;
    }
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: linear-gradient(0deg, #212541, #212541), #ffffff;
    }
    &::-webkit-scrollbar-thumb {
        background: rgb(110, 110, 110);
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgb(134, 134, 134);
    }
    &.hide {
        width: 0px;
        .premium_line span,
        .admin_line span {
            opacity: 0;
        }
        .change-log,
        .settings,
        .feedback,
        .nova_cenova_ponuka {
            display: none;
        }
        @media only screen and (max-width: 830px) {
            width: 0px;
        }
    }
    @media only screen and (max-height: 2000px) {
        overflow: auto;
    }
    .bottom {
        padding-bottom: 30px;
        .change-log {
            transition: 0.5s all;
            width: 100%;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 20px;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2ed8b6;
        }
    }
    .settings {
        transition: 0.5s all;
        margin: 14px auto 20px auto;
        width: 239px;
        height: 55px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-sizing: border-box;
        border-radius: 6px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
        cursor: pointer;
        svg {
            margin-right: 10px;
        }
        margin-bottom: 20px;
    }
    .feedback {
        margin-bottom: 10px;
        width: 100%;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-decoration: underline;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #bdbdbd;
    }
    .settings_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(0deg, #212541, #212541), #ffffff;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
        }
    }
    .nova_cenova_ponuka {
        transition: 0.5s all;
        margin: 0 auto;
        width: 239px;
        height: 55px;
        background: #2ed8b6;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        cursor: pointer;
        text-decoration: none;
        margin-top: 40px;
        svg {
            margin-right: 10px;
        }
        &.topmenu {
            height: 45px;
            margin-bottom: 10px;
            margin-top: 20px;
            width: 90%;
        }
    }
    .premium_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            background: #fbbf24;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
            svg {
                margin-right: 5px;
            }
        }
    }
    .admin_line {
        margin: 27px 0;
        position: relative;
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.3);
        span {
            transition: 0.5s all;
            position: absolute;
            left: 30px;
            top: -10px;
            width: 91px;
            height: 20px;
            background: #4338ca;
            border-radius: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 9px;
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            color: #ffffff;
        }
    }
}
</style>